import "./BenefitsSectionPlan.css";
import AcceleratedIcon from "../../Assets/Images/accelerate-benefit-icon.svg";
import AutomaticIcon from "../../Assets/Images/automatic-benefit-icon.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook
import coverImage from "../../Assets/Images/term-benefits-img-2.png";

const BenefitSectionPlanPage2 = ({ titleText, price, sectionRef }) => {
  const translations = useTranslation(); // Get translations dynamically
  return (
    <div
      id="terms-benefits"
      className="item2 benefits-section-layout flex py-12 lg:py-32 flex-wrap flex-col-reverse lg:flex-col md:flex-nowrap"
    >
      <div className="container">
        <div className="flex-1 shrink order-last lg:w-[50%] py-[40px] lg:order-first lg:px-0 px-4">
          <div className="pb-[10%] md:pb-[15%] lg:pb-[30%] hidden lg:block animate__animated animate__fadeInLeft">
            <div className="text-sm text-gray-600 mb-1 learnmoreacc">
              {translations.select_term}
            </div>
            <div className="text-[40px] leading-[44px] tracking-tight extra-title-heading">
              <span className="font-semibold">
                {translations.main_benefits}
              </span>{" "}
              {translations.of_the_policy}
            </div>
          </div>
          <div>
            <div className="flex pb-[4.5rem] animate__animated animate__fadeInLeft benefits-policy-grid">
              <div className="pe-[1.8rem] flex-none">
                <img src={AcceleratedIcon} className=" w-[84px]" />
              </div>
              <div className="max-w-[355px] benefits-policy-content-vs">
                <h3 className="md:text-[24px] text-[16px] font-semibold md:mb-2.5 mb-2 md:leading-[28px] leading-[20px] tracking-tight">
                  {translations.acceleratedDeathBenefitTitle}
                </h3>
                <p className="md:text-[16px] text-[14px] md:leading-[22px] leading-[20px]">
                  {translations.acceleratedDeathBenefitDesc}
                </p>
              </div>
            </div>
            <div className="flex animate__animated animate__fadeInLeft benefits-policy-grid">
              <div className="pe-[1.8rem] flex-none">
                <img src={AutomaticIcon} className=" w-[84px]" />
              </div>
              <div className="max-w-[355px] benefits-policy-content-vs">
                <h3 className="md:text-[24px] text-[16px] font-semibold md:mb-2.5 mb-2 md:leading-[28px] leading-[20px] tracking-tight">
                  {translations.automaticBenefitRiderTitle}
                </h3>
                <p className="md:text-[16px] text-[14px] md:leading-[22px] leading-[20px] ">
                  {translations.automaticBenefitRiderDesc}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="tab-capsule-img-box relative lg:absolute w-[100%] lg:w-[50%] pl-[20px] right-0">
        <div className="tab-capsule-inner-box flex-1 w-[100%] flex-none !ml-auto ms-[5%] mt-[5%] md:mt-0 order-first lg:order-last">
          <div className="px-4 lg:px-[0] pb-[5%] block lg:hidden animate__animated animate__fadeInLeft">
            <div className="text-[16px] lg:text-[18px] font-normal">
              Select Term
            </div>
            <div className="text-[24px] lg:text-[40px]">
              <span className="font-semibold">Main benefits</span> of the policy
            </div>
          </div>
          <div className="circle-div lg:ml-0 mb-[0] md:mb-0 max-h-[688px] animate__animated animate__fadeInRight">
            <img src={coverImage} width={"100%"} className="object-cover" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitSectionPlanPage2;
